module.exports = __webpack_public_path__ + "img/TZS09656.9546f88c.jpeg";